import { style } from 'typestyle'
export const mb24 = style({ marginBottom: '24px' })
